module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tilføj bil"
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Tilføj")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', {
    staticClass: "compare-wrapper"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('div', {
      staticClass: "line__value"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.removeVehicle(index)
        }
      }
    }, [_vm._v("Fjern")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(vehicle.general.MaerkeTypeNavn) + "\n                    " + _vm._s(vehicle.general.ModelTypeNavn))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(vehicle.general.VariantTypeNavn) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Model årgang\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.ModelAar) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Indregistreret\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(vehicle.general.FoersteRegistreringDato, 'D[.] MMMM YYYY')) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Motor\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorStoerrelse) + "L\n                    "), (vehicle.general.MotorCylinderAntal) ? _c('span', [_vm._v("(" + _vm._s(vehicle.general.MotorCylinderAntal) + " cyl.)")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(vehicle.general.DrivkraftTypeNavn) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Effekt\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorHestekraefter) + " HK\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Max hastighed\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [(vehicle.general.MaksimumHastighed) ? _c('span', [_vm._v("\n                        " + _vm._s(vehicle.general.MaksimumHastighed) + " km/t\n                    ")]) : _c('span', [_vm._v("\n                        -\n                    ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Egenvægt\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [(vehicle.general.EgenVaegt) ? _c('span', [_vm._v("\n                        " + _vm._s(vehicle.general.EgenVaegt) + " kg\n                    ")]) : _c('span', [_vm._v("\n                        -\n                    ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Forbrug\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                    " + _vm._s(vehicle.general.MotorKmPerLiter) + " km/l\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }, [_vm._v("\n                    Halvårlig afgift\n                ")]), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    }, _vm._l((vehicle.dmr.Afgift.AfgiftDetaljer), function(afgift) {
      return (afgift.AfgiftType === 'Sum') ? _c('div', [_vm._v("\n                        " + _vm._s(afgift.Pris) + "\n                    ")]) : _vm._e()
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__meta"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle) {
    return _c('div', {
      staticClass: "line__value"
    })
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3b215d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/compare.vue
// module id = 360
// module chunks = 1